import React from 'react';
import {motion} from 'framer-motion';
import { AES, enc } from "crypto-js";
import Quill from 'quill';
import moment from 'moment';

/* eslint-disable security/detect-object-injection */
export const handleInput = (e, setState, setSubmitSelected, setMessage, submitSelected) => {
    const { id, value } = e.target;
    if(submitSelected) {
        setSubmitSelected(false);
        setMessage('');
    }
    setState((prv) => ({
        ...prv,
        [id]: value
    }));
}

export const handleValidation = (state) => {
    let flag = true;
    Object.keys(state).forEach((key) => {
        switch(key) {
        default:
            if(state[key].trim() === '') {
                flag = false;
            }
        }
    })
    return flag;
};

export const handleToast = (message, event, setMessage, selectedLanguage) => {
    let ui = ''
    if(event === 'error') {
        ui = <motion.div
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.3,
                ease: [0, 0.71, 0.2, 1.01],
            }}
            className='flex justify-center'>
            <div className='bg-[#B51803] flex justify-between p-[10px] rounded items-center mb-[24px] w-fit'>
                <p className={`w-full break-words font-normal text-sm text-[#F2F2F2] ${selectedLanguage === 'ar' ? 'ml-[20px]' : 'mr-[20px]'} pr-[8px]`}>{message}</p>
                <img onClick={() => setMessage('')} src='/images/Close.svg' className='cursor-pointer' alt="close" />
            </div>
        </motion.div>
    }
    return ui;
}

export function generateDeviceFingerprint() {
    const fingerprintComponents = [];
  
    // Collect various properties
    fingerprintComponents.push(navigator.userAgent);
    fingerprintComponents.push(navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '');
    fingerprintComponents.push(window.screen.colorDepth || -1);
    fingerprintComponents.push(window.screen.width || -1);
    fingerprintComponents.push(window.screen.height || -1);
    fingerprintComponents.push(new Date().getTimezoneOffset());
  
    // You can add more components based on your needs
  
    // Combine components to create a fingerprint
    const fingerprint = fingerprintComponents.join('');
  
    return fingerprint;
}

export function groupIntoPairs(arr) {
    const result = [];
    for (let i = 0; i < arr.length; i += 2) {
        const pair = [arr[i], arr[i + 1]];
        result.push(pair);
    }
    return result;
}

export const decryptMessage = (cipher, secret) => {
    let bytes;
    try {
        bytes = AES.decrypt(cipher, secret);
        const decrypted = bytes.toString(enc.Utf8);
        return decrypted
    } catch (err) {
        console.log('UNABLE TO DECIPHER', err);
    }
};

export function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
}

export function checkKeysInArray(object, array) {
    const keys = Object.keys(object);

    for (const key of keys) {
        const lowercaseKey = key.toLowerCase();

        const foundKeyword = array.find(keyword => lowercaseKey.includes(keyword));

        if (foundKeyword !== undefined) {
            const matchingValue = object[key];
            return matchingValue;
        }
    }

    return null;
}

export const arrayToObject = (array) => {
    let objectUsingLoop = {};
    for (let i = 0; i < array.length; i ++) {
        const key = array[i].toLowerCase();
        objectUsingLoop = {
            ...objectUsingLoop,
            [key]: key
        };
    }
    return objectUsingLoop;
};

export function jsonToFile(jsonData, fileName) {
    const jsonString = JSON.stringify(jsonData, null, 2); // Convert JSON object to a formatted string
    const blob = new Blob([jsonString], { type: 'application/json' }); // Create a Blob with JSON data
    const file = new File([blob], fileName, { type: 'application/json' }); // Create a File with the Blob and set the file name
    return file;
}
  
export function isSubset(child_array, parent_array) { 
    const is_subset = child_array.some((input_value) => parent_array.includes(input_value))    
    return is_subset
}

export function findKeysWithValue(obj, value) {
    return Object.keys(obj).filter(key => obj[key].includes(value));
}

export const quillGetHTMLWithBlot = (inputDelta) => {
    if (!inputDelta) return null;

    const Embed = Quill.import('blots/embed');
    
    // Check if the blot is already registered
    if (!Quill.imports['formats/attribute']) {
        class AttributeBlot extends Embed {
            static create(value) {
                const node = super.create();
                node.setAttribute('contenteditable', 'false');
                node.setAttribute('class', 'attribute-span');

                const sanitizedValue = value.replace(/[{}]/g, '');
                node.textContent = `{${sanitizedValue}}`;
                return node;
            }

            static value(node) {
                return node.textContent.slice(1, -1);
            }
        }
        AttributeBlot.blotName = 'attribute';
        AttributeBlot.tagName = 'span';
        AttributeBlot.className = "attribute-span";

        Quill.register(AttributeBlot);
    }

    // console.log("Blot registered:", Quill.imports['formats/attribute']);

    // Create a temporary Quill instance
    const tempCont = document.createElement("div");
    const quill = new Quill(tempCont); // Temporary Quill instance

    // Set the input Delta
    quill.setContents(inputDelta);

    // Retrieve the HTML content
    const qlEditor = tempCont.getElementsByClassName("ql-editor")[0];

    // Replace spaces with non-breaking spaces
    function replaceSpacesInTextNodes(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = node.textContent
                .replace(/ /g, '\u00A0') // Replace spaces with &nbsp;
                .replace(/^\uFEFF/, ''); // Remove BOM if it exists
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            node.childNodes.forEach(replaceSpacesInTextNodes);
        }
    }

    replaceSpacesInTextNodes(qlEditor);

    return qlEditor.innerHTML;
};

export const replaceMergeFieldsInHtml = (html, mergeFieldValues) => {
    // Parse the string into a DOM structure
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    // Replace placeholders in spans with the 'attribute-span' class
    const spans = doc.querySelectorAll('span.attribute-span');
    spans.forEach((span) => {
        // Get the placeholder key from the span's content
        let spanText = span.querySelector('span[contenteditable="false"]')?.textContent.trim();
        spanText = spanText
            ?.replace(/^\s*{\s*|\s*}\s*$/g, '') // Remove surrounding {}
            .replaceAll(/\u00A0/g, '_') // Replace non-breaking spaces with underscores
            .replace(/^\uFEFF/, '') // Remove BOM
            .toLowerCase();
                
        // Replace the content if the placeholder key exists in the mappings
        let value = ''
        const rawDate = mergeFieldValues?.[spanText];
        if(spanText.includes('date')){
            // Check if the raw date ends with "T00:00:00.000Z"
            const isMidnightUTC = rawDate?.endsWith('T00:00:00.000Z')
            value = rawDate ? isMidnightUTC
                ? rawDate.split('T')[0].split('-').reverse().join('-') // Format as MM-DD-YYYY
                : moment(rawDate).format('MM-DD-YYYY hh:mm:ss')
                : '';
        } else if (spanText.includes('time')){
            value = rawDate ? moment(rawDate).format('h:mm:ss') : ''
        } else {
            value = mergeFieldValues?.[spanText]
        }
        span.querySelector('span[contenteditable="false"]').textContent = (value || '')  + ' ';
    });

    return doc.body.innerHTML
}

export const isValidDeltaOps = (deltaOps) => {
    return (
        deltaOps &&
        deltaOps.ops &&
            !(deltaOps.ops.length === 1 && deltaOps.ops[0].insert === "\n")
    );
};